import { Ticket } from "callable-data-objects";
import { CallableInput } from "Components/Shared";
import { Field, Formik } from "formik";
import { useTicket } from "Hooks/Endpoints";
import React from "react";
import { Button, Form } from "semantic-ui-react";
import { object, string } from "yup";

const AssignmentPutSchema = object().shape({
  id: string().required(),
  reference: string().required("Reference is required"),
  status: string().required("Status is required"),
});

const getInitValues = (ticket: Ticket) => {
  return {
    id: ticket.id,
    reference: ticket.assignmentRequest.portalReference
      ? ticket.assignmentRequest.portalReference
      : "",
    status: ticket.assignmentRequest.status
      ? ticket.assignmentRequest.status
      : "",
    updated: ticket.assignmentRequest.updated,
  };
};

const AssignmentReferenceForm = () => {
  const { ticket, updateAssignment } = useTicket();

  return (
    <Formik
      enableReinitialize={true}
      initialValues={getInitValues(ticket)}
      validationSchema={AssignmentPutSchema}
      onSubmit={(values, actions) => {
        updateAssignment(values);
      }}
    >
      {(props) => (
        <Form onSubmit={props.handleSubmit}>
          <Field
            name='reference'
            label='Reference'
            placeholder='Enter Reference'
            component={CallableInput}
          />
          <Field
            name='status'
            label='Status'
            placeholder='Enter Status'
            component={CallableInput}
          />
          <Field
            name='updated'
            label='Last Updated'
            disabled
            component={CallableInput}
          />
          <Button primary type='submit'>
            Update Assignment Details
          </Button>
        </Form>
      )}
    </Formik>
  );
};

export default AssignmentReferenceForm;
